import React from 'react';
import { bool, instanceOf } from 'prop-types';
import { useProduct } from '@thd-nucleus/data-sources';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Rating } from '@thd-olt-component-react/rating';
import './Overview.style.scss';
import { Histogram } from '@thd-olt-component-react/histogram';
import { RatingsAndReviewsMobileHeader } from '../Mobile/RatingsAndReviewsMobileHeader';
import { usePresentation } from '../../context/PresentationProvider';

// TODO: Rescope CSS
export const Overview = ({ itemId, reviewStatistics, filterCheckboxes, onFilterChange, selectedSentiment, clickableFilters, hideSecondaryRatings }) => {
  const { useCondensedLayout } = usePresentation();
  const { data, error, loading } = useProduct({ itemId, domains: ['identifiers', 'info', 'reviews'] });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const { product } = data || {};
  const { reviews } = product || {};
  const totalReviews = reviews?.ratingsReviews?.totalReviews || 0;
  const averageRating = reviews?.ratingsReviews?.averageRating || 0;
  const {
    averageOverallRating, ratingDistribution, recommendationPercentage, secondaryRatingsAverages = [], totalReviewCount
  } = reviewStatistics;

  // Use BV as primary but fallback to available product data
  const total = totalReviewCount || totalReviews;
  const average = averageOverallRating || Number(averageRating).toFixed(1);
  return (
    <Row>
      {!useCondensedLayout
      && (
        <Col xs="4">
          <ul className="ratings-and-reviews-overview__desktop__list">
            <li>
              <div>
                <span className="ratings-and-reviews-overview__desktop__list__review-count">{total} </span>
                Customer Reviews
              </div>
            </li>
            <li>
              <div className="ratings-and-reviews-overview__desktop__list__float-left ratings-and-reviews-overview__desktop__list--full-width">
                <Rating titleEnabled value={Number(average)} />
              </div>
            </li>
            <li>
              <div className="ratings-and-reviews-overview__desktop__list__float-left">{average} out of 5 stars overall</div>
            </li>
          </ul>
          {[null, undefined].indexOf(recommendationPercentage) === -1 &&
          <div className="ratings-and-reviews-overview__desktop__list__recommend-wrapper">
            <span
              className="ratings-and-reviews-overview__desktop__list__float-left__recommend-percentage">{recommendationPercentage}% </span>
            <span
              className="ratings-and-reviews-overview__desktop__list__float-left__recommend-cutomers-text">of customers recommended.</span>
          </div>
          }
        </Col>
      )}
      {useCondensedLayout
      && (
        <RatingsAndReviewsMobileHeader average={average} total={total} recommendationPercentage={recommendationPercentage} />
      )}
      {(ratingDistribution || []).length > 0
      && (
        <Col xs={!useCondensedLayout ? '4' : '12'}>
          {!useCondensedLayout && <div className="heading">Overall Ratings</div>}
          <Histogram
            totalReviews={total}
            ratings={ratingDistribution}
            clickableFilters={!useCondensedLayout}
            onFilterChange={onFilterChange}
            filterCheckboxes={filterCheckboxes}
            clickableFilters={clickableFilters}
            selectedSentiment={selectedSentiment}
          />
        </Col>
      )}
      {!hideSecondaryRatings && secondaryRatingsAverages.length > 1
      && (
        <Col xs="4">
          {!useCondensedLayout && <div className="heading">Attribute Ratings</div>}
          {secondaryRatingsAverages.map((secondaryRating) => {
            if (secondaryRating.AverageRating === undefined) {
              return null
            }
            const { AverageRating = '0', Id } = secondaryRating;
            const floatRating = Number.parseFloat(AverageRating).toFixed(1);
            return (
              <div key={`secondary_rating_${ Id }`}
                   className="review-secondary-ratings">
                <div className="review-label-secondary">{ Id } </div>
                <div className="review-dashed">
                  <Rating
                    value={ Number(floatRating) }
                    type="dash" orange/>
                </div>
                <div>
                  <span>{ floatRating }</span>
                </div>
              </div>
            );
          })}
        </Col>
      )}
    </Row>
  );
};

Overview.displayName = 'RatingsAndReviewsOverview';

Overview.propTypes = {
  reviewStatistics: instanceOf(Object).isRequired,
  hideSecondaryRatings: bool
};

Overview.defaultProps = {
  hideSecondaryRatings: false
}
